import { EasePortalConstants } from './../constants/ease-portal-constants';
import { ActivatedRouteSnapshot, CanActivate, UrlTree, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../core/reducers';
import { selectIsLoggedIn } from '../../core/selectors/auth.selectors';
import { login } from '../../core/actions/auth.actions';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(private store: Store<AppState>,
                private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
        return this.store.select(selectIsLoggedIn)
            .pipe(map(loggedIn => {
                if (loggedIn && route.url[0].path === EasePortalConstants.APP_ROUTES.INITIAL_REQUEST) {
                    this.store.dispatch(login({ redirectToEuLogin: true }));
                    return true;
                }
                return loggedIn ? loggedIn : this.router.createUrlTree(['/', EasePortalConstants.APP_ROUTES.PAGE403]);
            }));
    }
}
